import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router'
import '../stile-avvisi.css'
import { useSessione } from '../servizi/sessione.tsx'
import { chiediPermesso, leggiPreferenze, notificheComputerPossibili, seguiPreferenze, statoPermesso } from '../servizi/avvisi.ts'
import { Bottone, BottoneIcona } from './base.tsx'
import { IconaCampana, IconaChiudi } from './Icone.tsx'

const RIMANDO_GIORNI = 30
const chiave = (utente: string) => `cidis-avvisi-proposta:${utente}`

function rimandata(utente: string): boolean {
  try { return Number(localStorage.getItem(chiave(utente))) > Date.now() } catch { return false }
}
function rimanda(utente: string) {
  try { localStorage.setItem(chiave(utente), String(Date.now() + RIMANDO_GIORNI * 86_400_000)) } catch { /* chiusa per la pagina */ }
}

/**
 * Proposta delle notifiche del computer (2/11/2026), nella stessa forma delle altre righe in cima: il
 * permesso del browser si chiede solo da qui o dalla pagina Notifiche, con un clic della persona, mai
 * all'apertura della pagina. Compare solo nel browser di un computer, finche' il permesso non e' stato ne'
 * dato ne' negato; la crocetta la nasconde per trenta giorni. Non compare impersonando, ne' nella pagina
 * Notifiche, che ha gia' il suo riquadro.
 */
export function AvvisoNotificheComputer() {
  const { io } = useSessione()
  const { pathname } = useLocation()
  const [, ridisegna] = useState(0)
  useEffect(() => seguiPreferenze(() => ridisegna((n) => n + 1)), [])

  if (!io || io.impersonazione || pathname === '/notifiche' || !notificheComputerPossibili()) return null
  if (statoPermesso() !== 'default' || !leggiPreferenze(io.id).sistema || rimandata(io.id)) return null

  const chiudi = () => { rimanda(io.id); ridisegna((n) => n + 1) }
  return (
    <div className="avvisi-proposta" role="status">
      <IconaCampana />
      <p>
        <strong>Avvisi anche con il gestionale in secondo piano</strong>: una notifica del computer per le email e
        gli avvisi nuovi, senza mittente né contenuto. <Link to="/notifiche#avvisi-computer">Che cosa compare</Link>
      </p>
      <Bottone variante="secondario" dimensione="piccolo" onClick={() => void chiediPermesso()}>
        Attiva le notifiche del computer
      </Bottone>
      <BottoneIcona icona={<IconaChiudi />} etichetta="Chiudi la proposta per trenta giorni" onClick={chiudi} />
    </div>
  )
}
